import { render, staticRenderFns } from "./FormUbicacionPago.vue?vue&type=template&id=8e66579a&"
import script from "./FormUbicacionPago.vue?vue&type=script&lang=js&"
export * from "./FormUbicacionPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports